import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { api, formatApiErrorDetail } from "../../lib/api";
import { fmtDate } from "./bookingFormat";

const CONSULTANTS = [["prof-ian-wilkinson", "Professor Ian Wilkinson"], ["dr-joseph-cheriyan", "Dr Joseph Cheriyan"], ["dr-johann-graggaber", "Dr Johann Graggaber"]];

export const ConsultantInviteDialog = ({ row, onClose, onDone }) => {
  const [slug, setSlug] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { setSlug(row?.consultant_slug || ""); }, [row]);

  const send = async () => {
    if (!slug) return toast.error("Please choose the consultant.");
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/bookings/${row.id}/consultant-invite`, { consultant_slug: slug });
      toast.success(`Invite for ${fmtDate(data.booking.start_time)} sent to ${data.sent_to.join(", ")}`);
      onDone();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={!!row} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="consultant-invite-dialog" className="bg-cream-50">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">Send invite to consultant</DialogTitle>
          <DialogDescription>{row?.patient_name}{row?.start_time ? ` · ${fmtDate(row.start_time)}` : ""}</DialogDescription>
        </DialogHeader>
        <label className="block text-sm"><span className="text-xs uppercase tracking-[0.16em] text-ink-muted">Consultant</span>
          <select value={slug} onChange={(e) => setSlug(e.target.value)} data-testid="consultant-invite-select"
            className="mt-1 w-full rounded-sm border border-stone-300 bg-white px-3 py-2 text-sm">
            <option value="" disabled>Choose…</option>
            {CONSULTANTS.map(([s, n]) => <option key={s} value={s}>{n}</option>)}
          </select></label>
        <p className="text-xs text-ink-muted">Sends a &quot;New CCPC booking&quot; email and calendar invite to the consultant&apos;s booking addresses (full name to NHS, initials to others). For Calendly bookings it first picks up any time change made in Calendly. The patient isn&apos;t emailed.</p>
        <DialogFooter>
          <button type="button" onClick={onClose} className="btn-secondary" data-testid="consultant-invite-close">Close</button>
          <button type="button" onClick={send} disabled={busy} className="btn-primary disabled:opacity-60" data-testid="consultant-invite-send">{busy ? "Sending…" : "Send invite"}</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
